// Backend max-length constraints (mirrors BATS.Application/Domain/DomainConstants.cs).
// Source of truth: FluentValidation rules on the .NET API. Keep these aligned when the
// backend constants change.
export const FormMaxLengths = {
    Email: 50,
    ContactPhone: 50,
    Phone: 20,
    Fax: 20,
    Name: 50,
    ContactName: 500,
    FullName: 100,
    Company: 500,
    Address: 500,
    City: 50,
    State: 50,
    PostalCode: 10,
    Country: 50,
    ShortLink: 100,
    Ip: 15,
} as const;

export const SignedByLengths = {
    Min: 3,
    Max: FormMaxLengths.Name,
} as const;

export const BolUpload = {
    AllowedExtensions: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf'] as const,
    MaxSizeBytes: 20 * 1024 * 1024,
    InvalidExtensionMessage: 'Only jpg, jpeg, png, gif, bmp, and pdf files are allowed.',
    OversizeMessage: 'File size must not exceed 20MB.',
} as const;
